import { render, staticRenderFns } from "./GpsChip.vue?vue&type=template&id=0b4e48b7"
import script from "./GpsChip.vue?vue&type=script&lang=ts"
export * from "./GpsChip.vue?vue&type=script&lang=ts"
import style0 from "./GpsChip.vue?vue&type=style&index=0&id=0b4e48b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports